export enum BLOG_TYPE {
  NOTE = "note",
  PAGE = "page",
}

export enum MODE {
  DARK = "dark",
  LIGHT = "light",
}
